import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sx-tarifa-importacion-form',
  templateUrl: 'tarifa.importacion.form.component.html'
})
export class TarifaImportacionFormComponent implements OnInit {
  private SERVICIO = 'SrvCotizacion';
  tipo: string;
  idTabla: number;
  errores = {
    'tipo': null,
    'idTabla': null,
  };

  constructor(private aRoute: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {

  }

  validar() {
    this.errores = {
      'tipo': null,
      'idTabla': null,
    };

    let esValido = true;
    if (!this.tipo) {
      this.errores.tipo = 'VALOR_REQUERIDO';
      esValido = false;
    }

    if (!this.idTabla) {
      this.errores.idTabla = 'VALOR_REQUERIDO';
      esValido = false;
    }

    return esValido;
  }

  getFormData() {
    return {
      idTabla: this.idTabla,
      tipo: this.tipo,
    };
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/importacionMasiva/forms/tarifa.importacion.form.component.ts